import template   from './my-purchase.html'
import controller from './my-purchase.controller'
import './my-purchase.styl'

let component = {
  restrict: 'E',
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/manage-purchase/my-purchase/my-purchase.component.js